import { render, staticRenderFns } from "./BlogSlider.vue?vue&type=template&id=2dc5e2dc"
import script from "./BlogSlider.vue?vue&type=script&lang=js"
export * from "./BlogSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports